module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch4_20210921085334_T.0ebe93c6.jpg";